import { createEvent } from "effector";

export const resetAllSelectedStores = createEvent("RESET_ALL_SELECTED");
